import PartnerContainer from './components/PartnerContainer.ce.vue'
import store from "./store";
import {defineCustomElement} from "./defineCustomElementWithPlugins";

store.dispatch('fetchPartners');

const partnerContainerElement = defineCustomElement(PartnerContainer, { plugins: [store] });

customElements.define('amecke-partner-container', partnerContainerElement)
